import { render, staticRenderFns } from "./ArticleManageDetail.vue?vue&type=template&id=18a65e56&scoped=true"
import script from "./ArticleManageDetail.vue?vue&type=script&lang=ts"
export * from "./ArticleManageDetail.vue?vue&type=script&lang=ts"
import style0 from "./ArticleManageDetail.vue?vue&type=style&index=0&id=18a65e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a65e56",
  null
  
)

export default component.exports